import { PaginatedTableWrapperColumns } from 'components/TableWrapper/components/PaginatedTableWrapper/types';
import { GMP_OBJECT_STATUS_NAME_BY_CODE } from 'modules/gmp/const';
import { GmpObjectStatus } from 'modules/gmp/types';

export const columns: PaginatedTableWrapperColumns[] = [
  {
    dataFormatter: (item) => GMP_OBJECT_STATUS_NAME_BY_CODE[item.statusCode as GmpObjectStatus],
    key: 'statusCode',
    title: 'Статус GMP',
  },
  {
    dataFormatter: ({ eaeuTransaction }) => eaeuTransaction.requestDate,
    key: 'eaeuTransaction.requestDate',
    title: 'Дата и время запроса',
  },
  {
    dataFormatter: ({ eaeuTransaction }) => eaeuTransaction.status?.name,
    key: 'eaeuTransaction.handlingStatus',
    title: 'Статус обработки',
  },
  {
    dataFormatter: ({ eaeuTransaction }) => eaeuTransaction.responseDate,
    key: 'eaeuTransaction.responseDate',
    title: 'Дата и время ответа',
  },
  {
    dataFormatter: ({ eaeuTransaction }) => eaeuTransaction?.errorMessage,
    key: 'eaeuTransaction.errorMessage',
    title: 'Ошибка',
  },
  {
    dataFormatter: ({ eaeuTransaction }) => eaeuTransaction?.user?.fio,
    key: 'eaeuTransaction.user',
    title: 'Пользователь',
  },
];
